<app-bottom-sheet [(isOpen)]="isOpen"
                  leftButtonText="Cancel"
                  [leftButtonDisabled]="isSaving()"
                  [rightButtonText]="isSaving() ? 'Saving...' : 'Select'"
                  [rightButtonDisabled]="isSaving() || !hasSelection()"
                  [preventOverlayClose]="true"
                  [headerTemplate]="headerTemplate"
                  [contentTemplate]="contentTemplate"
                  (leftButtonClick)="onLeftButtonClick()"
                  (rightButtonClick)="onRightButtonClick()"
                  data-testid="vendor-selection-bottom-sheet">
</app-bottom-sheet>

<ng-template #headerTemplate>
  <div class="vendor-header-content"
       data-testid="vendor-header-content">
    <h2 class="vendor-title"
        data-testid="vendor-title"
        id="vendor-title">Select Vendor</h2>
    <div class="search-container"
         data-testid="search-container">
      <input type="text"
             class="search-input"
             placeholder="Search for Vendor"
             [disabled]="isSaving()"
             [value]="searchTerm()"
             (input)="onSearchChange($event)"
             data-testid="vendor-search-input"
             aria-label="Search for vendors" />
      <i [class]="searchTerm() ? 'pi pi-times search-icon clear-icon' : 'pi pi-search search-icon'"
         (click)="searchTerm() ? onClearSearch() : null"
         [class.clickable]="searchTerm()"
         data-testid="search-icon"
         [attr.aria-label]="searchTerm() ? 'Clear search' : null"
         [attr.role]="searchTerm() ? 'button' : null"
         [attr.tabindex]="searchTerm() ? '0' : null"
         aria-hidden="true"></i>
    </div>
  </div>
</ng-template>

<ng-template #contentTemplate>
  <div class="vendor-content"
       data-testid="vendor-content"
       aria-live="polite"
       aria-label="Vendor list">
    <div class="vendors-list"
         data-testid="vendors-list">
      <div class="vendor-item assign-to-me-item"
           data-testid="assign-to-me-item">
        <label class="vendor-radio-label assign-to-me-label"
               [class.selected]="isAssignToMeSelected()"
               data-testid="assign-to-me-label">
          <input type="radio"
                 name="vendorSelection"
                 value="assign-to-me"
                 [checked]="isAssignToMeSelected()"
                 (change)="onAssignToMeSelect()"
                 [disabled]="isSaving()"
                 class="vendor-radio"
                 data-testid="assign-to-me-radio" />
          <div class="vendor-info assign-to-me-info"
               data-testid="assign-to-me-info">
            <div class="vendor-details"
                 data-testid="assign-to-me-details">
              <span class="vendor-name assign-to-me-name"
                    data-testid="assign-to-me-name">Assign Item to Me (CM)</span>
              @if (isAssignToMeSelected()) {
                <span class="assign-to-me-subtext"
                      data-testid="assign-to-me-subtext">Assigning this item to yourself will remove any vendor selection.</span>
              }
            </div>
          </div>
        </label>
      </div>

      <div class="vendor-divider"
           data-testid="vendor-divider"></div>

      @if (vendors().length === 0) {
        <div class="no-results"
             data-testid="no-vendor-results"
             role="status"
             aria-live="polite">
          <p data-testid="no-vendor-results-text">Loading vendors...</p>
        </div>
      } @else if (filteredVendors().length === 0) {
        <div class="no-results"
             data-testid="no-vendor-results"
             role="status"
             aria-live="polite">
          <p data-testid="no-vendor-results-text">No vendors found matching your search.</p>
        </div>
      } @else {
        @for (vendor of filteredVendors(); track vendor.id) {
          <div class="vendor-item"
               [attr.data-testid]="'vendor-item-' + vendor.id">
            <label class="vendor-radio-label"
                   [class.selected]="selectedVendorId() === vendor.id"
                   [attr.data-testid]="'vendor-radio-label-' + vendor.id">
              <input type="radio"
                     name="vendorSelection"
                     [value]="vendor.id"
                     [checked]="selectedVendorId() === vendor.id"
                     (change)="onVendorSelect(vendor.id)"
                     [disabled]="isSaving()"
                     class="vendor-radio"
                     [attr.data-testid]="'vendor-radio-' + vendor.id" />
              <div class="vendor-info"
                   [attr.data-testid]="'vendor-info-' + vendor.id">
                <div class="vendor-details"
                     [attr.data-testid]="'vendor-details-' + vendor.id">
                  <span class="vendor-name"
                        [attr.data-testid]="'vendor-name-' + vendor.id">{{ vendor.name | titlecase }}</span>
                  @if (vendor.name.toLowerCase() !== vendor.doingBusinessAs.toLowerCase()) {
                    <span class="vendor-description"
                          [attr.data-testid]="'vendor-description-' + vendor.id">Also known as: {{ vendor.doingBusinessAs | titlecase }}</span>
                  }
                </div>
              </div>
            </label>
          </div>
        }
      }
    </div>
  </div>
</ng-template>